import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({})
export class HardwareRegistrationStatus extends Mappable {
  id!: string
  title!: string
  colour!: string

  static create<Data>(attrs: Data) {
    return new HardwareRegistrationStatus().map(attrs)
  }
}
